export interface DetailTarget {
  applicationId: string
  componentId?: string
  incidentId?: string
}

const RELAY_URL = 'https://health.sasid.ai/'
const MAX_TARGET_LENGTH = 180

function bounded(value: string | null): string | undefined {
  const clean = value?.trim()
  if (!clean || clean.length > MAX_TARGET_LENGTH) return undefined
  return clean
}

export function parseDetailTarget(search: string): DetailTarget | undefined {
  const params = new URLSearchParams(search)
  const applicationId = bounded(params.get('app'))
  if (!applicationId) return undefined
  return {
    applicationId,
    componentId: bounded(params.get('component')),
    incidentId: bounded(params.get('incident')),
  }
}

export function applyDetailTarget(url: URL, target?: DetailTarget): URL {
  if (!target) {
    url.searchParams.delete('app')
    url.searchParams.delete('component')
    url.searchParams.delete('incident')
    return url
  }

  url.searchParams.set('app', target.applicationId)
  if (target.componentId) url.searchParams.set('component', target.componentId)
  else url.searchParams.delete('component')
  if (target.incidentId) url.searchParams.set('incident', target.incidentId)
  else url.searchParams.delete('incident')
  return url
}

export function relayDetailUrl(target?: DetailTarget, baseUrl = RELAY_URL): string {
  return applyDetailTarget(new URL(baseUrl), target).toString()
}
